import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {getCustomerLoyaltyTransactionsState, getSelectedStore} from '../../+state/stores.selectors';
import {Page} from '../../../../api/types/Page';
import {ClientStore, CustomerLoyaltyTrasaction} from '../../../../stores/stores';
import {LoadCustomerLoyaltyTransactions} from '../../+state/stores.actions';
import {Paging} from '../../../../api/types/Pageable';
import StoreUtils from '../../utils/StoreUtils';

@Component({
  selector: 'app-profile-loyalty-points-transactions',
  templateUrl: './profile-loyalty-points-transactions.component.html',
  styleUrl: './profile-loyalty-points-transactions.component.scss'
})
export class ProfileLoyaltyPointsTransactionsComponent implements OnInit, OnDestroy {

  readonly DEFAULT_PAGE_SIZE: number = 10;

  unsubscribe$: Subject<void> = new Subject<void>();

  loyaltyTrasactions = [];
  transactionsPage: Page<CustomerLoyaltyTrasaction>;
  selectedStore: ClientStore;
  selectedStoreCurrency: string;
  selectedStoreCurrencySymbol: string;
  status: 'INITIAL' | 'LOADING' | 'SUCCESS' | 'FAILED';

  constructor(
    private store: Store<any>,
  ) {
  }

  ngOnInit() {
    this.store
      .select(getCustomerLoyaltyTransactionsState)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((transactionsState) => {
        this.transactionsPage = transactionsState.data;
        this.status = transactionsState.status;

        if (this.status === 'SUCCESS') {
          this.loyaltyTrasactions = this.transactionsPage.content;
        } else if (this.status === 'FAILED') {
          this.loyaltyTrasactions = [];
        } else if (this.status === 'INITIAL') {
          const paging: Paging = {
            page: 0,
            size: this.DEFAULT_PAGE_SIZE
          };
          this.store.dispatch(new LoadCustomerLoyaltyTransactions(paging, {
            src: 'ProfileLoyaltyPointsTransactionsComponent',
            description: 'First load of loyalty points transactions',
          }));
        }
      });

    this.store.pipe(select(getSelectedStore))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(selectedStore => {
        this.selectedStore = selectedStore;
        if (selectedStore) {
          this.selectedStoreCurrencySymbol = selectedStore.currency.symbol;
          if (selectedStore?.currency) {
            this.selectedStoreCurrency = StoreUtils.getCurrencyIsoCode(selectedStore);
            this.selectedStoreCurrencySymbol = StoreUtils.getCurrencySymbol(selectedStore);
          }
        }
      });
  }

  paginate(paging: Paging) {
    this.store.dispatch(new LoadCustomerLoyaltyTransactions(paging, {
      src: 'ProfileLoyaltyPointsTransactionsComponent',
      description: 'Paginate loyalty points transactions',
    }));
  }

  getLocale() {
    return this.selectedStore?.locale || navigator.language || 'en-US';
  }

  getTimeZone() {
    return this.selectedStore?.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
